// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_1NMvNFs","successModal":"_2oAUiQQ","container":"_1UAi4EZ","imageContainer":"_1ZTyDQI","tick":"_-Msr5w-","content":"_zB3A98Q","button":"_2S49DkG"};